<template>
<el-container>
  <el-header class="main-body-search">
    <el-row :gutter="20">
      <el-col :span=4>
          <el-input v-model="searchText" @keyup.enter.native="doSearch(true)" placeholder="查询条件" suffix-icon="el-icon-search">
          </el-input>
      </el-col>
      <el-col :span=4 class="search">
        <el-button icon='el-icon-search' @click="doSearch(true)" type="primary">查询</el-button>
      </el-col>
      <el-col :span=2 class="add">
        <el-button type="success" @click="addFirstReleaseFormVisible = true; dialogTitle = '新增首次发布'; isNewVersion = true;">首次发布</el-button>
      </el-col>
      <el-col :span=2 class="add">
        <el-button type="success" @click="updatePatchFormVisible = true; dialogTitle = '新增升级发布'; isNewVersion = true;">升级发布</el-button>
      </el-col>
    </el-row>
  </el-header>
  <!-- 增加 end -->
  <!-- 列表 start -->
  <el-main class="main-body-table">
    <el-table :data="tableList" style="width: 100%" max-height="500">
      <el-table-column fixed prop="appName" label="应用简称">
      </el-table-column>
      <el-table-column fixed prop="appFullName" label="应用全称">
      </el-table-column>
      <el-table-column fixed prop="appTypeLabel" label="应用类型" width="80">
      </el-table-column>
      <el-table-column fixed prop="platform" label="适用操作系统" width="110">
      </el-table-column>
      <!-- <el-table-column fixed prop="lowestOsVersion" label="适用最低版本" width="100">
      </el-table-column> -->
      <el-table-column fixed prop="versionCode" label="应用版本号" width="100">
      </el-table-column>
      <!-- <el-table-column fixed prop="versionName" label="应用版本名称" width="100">
      </el-table-column> -->
      <el-table-column fixed prop="versionDesc" label="应用发版说明">
      </el-table-column>
      <el-table-column fixed prop="packageNameShow" label="升级包文件">
      </el-table-column>
      <el-table-column fixed prop="packageSizeShow" label="文件大小">
      </el-table-column>
      <!-- <el-table-column fixed prop="packageType" label="升级包类型" width="80">
      </el-table-column>
      <el-table-column fixed prop="diffVersionCode" label="该差分包适用的版本号" width="150">
      </el-table-column> -->
      <el-table-column fixed prop="releaseDateStr" label="发布日期" width="100">
      </el-table-column>
      <el-table-column fixed prop="firstReleaseLabel" label="是否首次发布" width="110">
      </el-table-column>
      <el-table-column  fixed="right"  label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-edit" circle @click.native.prevent="updateShow(scope.$index, scope.row)" size="small"></el-button>
          <el-button type="danger" icon="el-icon-delete" circle @click.native.prevent="deletePostSubmit(scope.$index,scope.row)" size="small"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="main-body-table-page" layout="total, sizes, prev, pager, next, jumper"
      @current-change="handleCurrentChange" :current-page="page.current"
      :page-size="page.size" :total="total"
      @size-change="handleSizeChange">
    </el-pagination>
  <!-- 分页 start -->
  <!-- <el-col :span="24" class="toobar">
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page=page.current :page-sizes=pagesizes :page-size=page.size layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
  </el-col> -->
  <!-- 分页 end -->
  </el-main>
  <!-- 列表 end -->

 <!-- 新增或编辑首次发布表单 start-->
 <el-dialog :title="dialogTitle" width="35%" :before-close="beforeClose" @close="closeDialog" :close-on-click-modal="false" :visible.sync="addFirstReleaseFormVisible">
    <el-form ref="refaddFirstReleaseForm" :rules="formRules" :model="addFirstReleaseForm" label-width="120px" size="medium">
      <el-form-item label="应用简称" prop="appName">
        <el-input :disabled="!isNewVersion" v-model="addFirstReleaseForm.appName"></el-input>
      </el-form-item>
      <el-form-item label="应用全称" prop="appFullName">
        <el-input v-model="addFirstReleaseForm.appFullName"></el-input>
      </el-form-item>
      <el-form-item label="应用类型">
        <el-select :disabled="!isNewVersion" v-model="addFirstReleaseForm.appType" placeholder="请选择">
          <el-option
            v-for="item in optionsAppType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="适用操作系统">
        <el-select v-model="addFirstReleaseForm.platform" placeholder="请选择">
          <el-option
            v-for="item in optionsPlatform"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="适用最低操作系统版本">
        <el-input v-model="addFirstReleaseForm.lowestOsVersion"></el-input>
      </el-form-item> -->
      <el-form-item label="版本号" prop="versionCode">
        <el-input v-model="addFirstReleaseForm.versionCode"></el-input>
      </el-form-item>
      <!-- <el-form-item label="版本名称">
        <el-input v-model="addFirstReleaseForm.versionName"></el-input>
      </el-form-item> -->
      <el-form-item label="发版说明" prop="versionDesc">
        <el-input v-model="addFirstReleaseForm.versionDesc" type="textarea" :rows="2"></el-input>
      </el-form-item>
      <el-form-item label="安装包文件MD5" prop="packageMd5">
        <el-input :disabled="!isNewVersion" v-model="addFirstReleaseForm.packageMd5"></el-input>
      </el-form-item>
      <el-form-item label="安装包文件" prop="packageName">
        <el-upload
          v-if="isNewVersion"
          class="upload-demo"
          :headers="{'SUM-TICKET': sumTicket}"
          :file-list="uploadFileList"
          drag
          action="/api/common/versionUpdate/upload"
          :before-upload="beforeUpload"
          :on-success="handleUploadSuccess"
          :before-remove="beforeUploadRemove"
          :on-remove="handleUploadRemove"
          :on-exceed="handleUploadExceed"
          :on-error="handleUploadError"
          :on-progress="handleUploadProgress"
          :limit="1"
          :multiple="multiple"
          v-model="addFirstReleaseForm.packageName"
          >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处, 或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传一个安装包文件, 最大200mb, 上传完成后再点击确定按钮</div>
        </el-upload>
        <el-input v-else :disabled="true" v-model="addFirstReleaseForm.packageNameShow"></el-input>
      </el-form-item>
      <!-- <el-form-item label="升级包类型">
        <el-input v-model="addFirstReleaseForm.packageType"></el-input>
      </el-form-item>
      <el-form-item label="该差分包适用的版本号">
        <el-input v-model="addFirstReleaseForm.diffVersionCode"></el-input>
      </el-form-item>
      <el-form-item label="发布日期">
        <el-input v-model="addFirstReleaseForm.releaseDate"></el-input>
      </el-form-item>
      <el-form-item label="是否该应用首次发布">
        <el-input v-model="addFirstReleaseForm.firstRelease"></el-input>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
       <el-button type="primary" @click="cancelButton">取 消</el-button>
       <el-button type="primary" @click="newSubmit">确 定</el-button>
     </div>
  </el-dialog>
  <!-- 新增或编辑首次发布表单 end-->
  <!-- 新增或编辑升级发布表单 start-->
  <el-dialog :title="dialogTitle" width="35%" :before-close="beforeClose" @close="closeDialog" :visible.sync="updatePatchFormVisible">
    <el-form ref="refupdatePatchForm" :rules="formRules" :model="updatePatchForm" label-width="120px" size="medium">
      <!-- <el-form-item label="应用简称" prop="appName">
        <el-input v-model="updatePatchForm.appName"></el-input>
      </el-form-item> -->
      <el-form-item label="应用名称" prop="appName">
        <el-select v-model="updatePatchForm.appName" placeholder="请选择">
          <el-option
            v-for="item in optionsAppFullName"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <!-- <el-input v-model="updatePatchForm.appFullName"></el-input> -->
      </el-form-item>
      <!-- <el-form-item label="应用类型" prop="appType">
        <el-select v-model="updatePatchForm.appType" placeholder="请选择">
          <el-option
            v-for="item in optionsAppType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="适用操作系统">
        <el-select v-model="updatePatchForm.platform" placeholder="请选择">
          <el-option
            v-for="item in optionsPlatform"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="适用最低的操作系统版本">
        <el-input v-model="updatePatchForm.lowestOsVersion"></el-input>
      </el-form-item> -->
      <el-form-item label="版本号" prop="versionCode">
        <el-input v-model="updatePatchForm.versionCode"></el-input>
      </el-form-item>
      <!-- <el-form-item label="版本名称">
        <el-input v-model="updatePatchForm.versionName"></el-input>
      </el-form-item> -->
      <el-form-item label="发版说明" prop="versionDesc">
        <el-input v-model="updatePatchForm.versionDesc" type="textarea" :rows="2"></el-input>
      </el-form-item>
      <el-form-item label="升级包文件MD5" prop="packageMd5">
        <el-input :disabled="!isNewVersion" v-model="updatePatchForm.packageMd5"></el-input>
      </el-form-item>
      <el-form-item label="升级包文件" prop="packageName">
        <el-upload
          v-if="isNewVersion"
          class="upload-demo"
          :headers="{'SUM-TICKET': sumTicket}"
          :file-list="uploadFileList"
          drag
          action="/api/common/versionUpdate/upload"
          :before-upload="beforeUpload"
          :on-success="handleUploadSuccess"
          :before-remove="beforeUploadRemove"
          :on-remove="handleUploadRemove"
          :on-exceed="handleUploadExceed"
          :on-error="handleUploadError"
          :on-progress="handleUploadProgress"
          :limit="1"
          :multiple="multiple"
          v-model="updatePatchForm.packageName"
          >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处, 或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传一个升级包文件, 最大200mb, 上传完成后再点击确定按钮</div>
        </el-upload>
        <el-input v-else :disabled="true" v-model="updatePatchForm.packageNameShow"></el-input>
      </el-form-item>
      <!-- <el-form-item label="升级包类型">
        <el-input v-model="updatePatchForm.packageType"></el-input>
      </el-form-item>
      <el-form-item label="该差分包适用的版本号">
        <el-input v-model="updatePatchForm.diffVersionCode"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="发布日期">
        <el-input v-model="updatePatchForm.releaseDate"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="是否该应用首次发布">
        <el-input v-model="updatePatchForm.firstRelease"></el-input>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="cancelButton">取 消</el-button>
      <el-button type="primary" @click="newSubmit">确 定</el-button>
    </div>
  </el-dialog>
  <!-- 新增或编辑升级发布表单 end-->
</el-container>
</template>

<script>
import {
  selectPageVersionUpdate,
  selectPageByFuzzy,
  selectFirstReleaseList,
  insertVersionUpdate,
  updateVersionUpdate,
  deleteVersionUpdate,
  deleteFileByPackageName
} from '../../api/sys/VersionUpdate'
export default {
  data() {
    return {
      sumTicket: sessionStorage.getItem('token'),
      multiple: false,
      uploading: false, // 是否上传中
      isNewVersion: true,
      uploadFileList: [],
      searchText: '',
      optionsAppType: [
        {
          value: 'mobile',
          label: '移动应用'
        }, {
          value: 'web',
          label: 'Web应用'
        }, {
          value: 'client',
          label: 'PC客户端应用'
        }
      ],
      optionsPlatform: [
        {
          value: 'Android',
          label: 'Android'
        },
        {
          value: 'iOS',
          label: 'iOS'
        },
        {
          value: 'Windows',
          label: 'Windows'
        }
      ],
      optionsAppFullName: [],
      firstReleaseList: [],
      total: 0,
      dialogTitle: '',
      pagesizes: [10, 20, 50, 100],
      // 新增或更新首次发布表单
      addFirstReleaseForm: {},
      // 新增或更新升级发布表单
      updatePatchForm: {},
      page:
      {
        size: 10,
        current: 1
      },
      addFirstReleaseFormVisible: false,
      updatePatchFormVisible: false,
      tableList: [],
      formRules: {
        appName: [
          {
            required: true,
            message: '请输入应用简称',
            trigger: 'blur'
          },
          { min: 1, max: 50, message: '长度在50个字以内', trigger: 'blur' }
        ],
        appFullName: [
          {
            required: true,
            message: '请输入应用全称',
            trigger: 'blur'
          },
          { min: 1, max: 120, message: '长度在120个字以内', trigger: 'blur' }
        ],
        versionCode: [
          {
            required: true,
            message: '请输入应用版本号',
            trigger: 'blur'
          },
          { required: true, min: 1, max: 20, message: '长度在20个字以内', trigger: 'blur' }
        ],
        versionDesc: [
          {
            required: true,
            message: '请输入应用发版说明',
            trigger: 'blur'
          },
          { min: 1, max: 480, message: '长度在480个字以内', trigger: 'blur' }
        ],
        packageMd5: [
          {
            required: false,
            message: '用于上传文件完整性校验',
            trigger: 'blur'
          },
          { min: 1, max: 50, message: '长度在50个字以内', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /**
     * 模糊查询
     * @param isFirst 是否是首次查询
     */
    doSearch(isFirst) {
      if (isFirst) {
        this.page = {
          size: 10,
          current: 1
        }
      }
      if (!this.searchText) {
        this.getlist()
        return
      }
      this.page.searchText = this.searchText

      selectPageByFuzzy(
        this.page
      )
        .then(res => {
          if (res.code === 20000) {
            this.tableList = res.data.records
            this.handleTableList(res)
          }
        })
        .catch(err => {
          this.$notify({
            title: 'error',
            message: '查询失败:' + err,
            type: 'error'
          })
        })
    },
    /**
     * 上传文件前的钩子
     */
    beforeUpload(file) {
      this.uploading = true
    },
    /**
     * 上传文件成功的钩子
     */
    handleUploadSuccess(res, file) {
      if (this.addFirstReleaseFormVisible) {
        this.addFirstReleaseForm.packageName = res.data
      } else {
        this.updatePatchForm.packageName = res.data
      }
      this.uploading = false
    },
    /**
     * 删除上传文件的钩子
     */
    handleUploadRemove(file, fileList) {
      if (this.addFirstReleaseFormVisible) {
        deleteFileByPackageName(
          { packageName: this.addFirstReleaseForm.packageName }
        ).then(res => {})
        this.addFirstReleaseForm.packageName = ''
      } else {
        deleteFileByPackageName(
          { packageName: this.updatePatchForm.packageName }
        ).then(res => {})
        this.updatePatchForm.packageName = ''
      }
    },
    /**
     * 上传文件数量超过限制的钩子
     */
    handleUploadExceed(files, fileList) {
      if (this.addFirstReleaseFormVisible) {
        this.$message({
          message: '仅允许上传一个安装包文件',
          type: 'error'
        })
      } else {
        this.$message({
          message: '仅允许上传一个升级包文件',
          type: 'error'
        })
      }
    },
    /**
     * 上传文件失败的钩子
     * 有三个参数err, file, fileList, 因为未使用所以删除
     */
    handleUploadError() {
      this.uploading = false
      this.$message({
        message: `文件上传失败，上传文件不可以超过200MB！`,
        type: 'error'
      })
    },
    /**
     * 上传文件进行中的钩子
     */
    handleUploadProgress(event, file, fileList) {
      this.uploading = true
    },
    /**
     * 删除上传文件前的钩子
     */
    beforeUploadRemove(file, fileList) {
      return this.$confirm(`确定删除文件[${file.name}]吗?`)
    },
    // 对话框右上角的×关闭前事件
    beforeClose(done) {
      if (this.uploading) {
        this.$message({
          message: `文件上传中，请等待`,
          type: 'error'
        })
        return
      }
      done()
    },
    // 对话框右下角的取消按钮事件
    cancelButton() {
      if (this.uploading) {
        this.$message({
          message: `文件上传中，请等待`,
          type: 'error'
        })
        return
      }
      this.addFirstReleaseFormVisible = false
      this.updatePatchFormVisible = false
      this.closeDialog()
    },
    /**
     * 关闭对话框处理
     */
    closeDialog() {
      if (this.isNewVersion && this.addFirstReleaseForm.packageName) {
        deleteFileByPackageName(
          { packageName: this.addFirstReleaseForm.packageName }
        ).then(res => {})
      }
      if (this.isNewVersion && this.updatePatchForm.packageName) {
        deleteFileByPackageName(
          { packageName: this.updatePatchForm.packageName }
        ).then(res => {})
      }
      this.resetAddFirstReleaseForm()
      this.resetUpdatePatchForm()
    },
    /**
     * 确定按钮提交记录
     */
    newSubmit() {
      if (this.addFirstReleaseFormVisible) {
        this.$refs['refaddFirstReleaseForm'].validate((valid) => {
          if (valid) {
            if (!this.addFirstReleaseForm.packageName) {
              this.$message({
                message: '请上传安装包文件',
                type: 'error'
              })
              return
            }
            if (this.addFirstReleaseForm.id) {
              // 更新首席发布
              updateVersionUpdate(
                this.addFirstReleaseForm
              ).then(res => {
                if (res.code === 20000) {
                  this.reset()
                }
              })
              return
            }
            // 新增首次发布
            insertVersionUpdate(
              this.addFirstReleaseForm
            ).then(res => {
              if (res.code === 20000) {
                this.reset()
              }
            })
          }
        })
      } else {
        this.$refs['refupdatePatchForm'].validate((valid) => {
          if (valid) {
            if (!this.updatePatchForm.packageName) {
              this.$message({
                message: '请上传升级包文件',
                type: 'error'
              })
              return
            }
            this.fillPatchForm(this.updatePatchForm)
            if (this.updatePatchForm.id) {
              // 更新升级发布
              updateVersionUpdate(
                this.updatePatchForm
              ).then(res => {
                if (res.code === 20000) {
                  this.reset()
                }
              })
              return
            }
            // 新增升级发布
            insertVersionUpdate(
              this.updatePatchForm
            ).then(res => {
              if (res.code === 20000) {
                this.reset()
              }
            })
          }
        })
      }
    },
    /**
     * 重置表单数据
     */
    reset() {
      this.resetAddFirstReleaseForm()
      this.resetUpdatePatchForm()
      this.getlist()
      if (this.isNewVersion) {
        this.getAppFullNamelist()
      }
      this.updatePatchFormVisible = false
      this.addFirstReleaseFormVisible = false
    },
    /**
     * 填充升级发布的表单项[appFullName, appType]
     */
    fillPatchForm(patchForm) {
      let a = this.firstReleaseList.filter(function(item) {
        return item.appName === patchForm.appName
      })
      patchForm.appFullName = a[0].appFullName
      patchForm.appType = a[0].appType
    },
    /**
     * 重置首次发布表单对象
     */
    resetAddFirstReleaseForm() {
      this.addFirstReleaseForm = {
        firstRelease: 1, // 首次发布
        appType: 'mobile',
        platform: 'Android',
        releaseDate: 0, // 发布日期，由服务端提供时间
        packageType: 1 // 完整包
      }
      this.uploadFileList = []
    },
    /**
     * 重置升级发布表单对象
     */
    resetUpdatePatchForm() {
      this.updatePatchForm = {
        firstRelease: 0, // 升级发布
        appType: 'mobile',
        platform: 'Android',
        releaseDate: 0, // 发布日期，由服务端提供时间
        packageType: 1 // 完整包
      }
      this.uploadFileList = []
    },
    handleSizeChange(val) {
      this.page.size = val
      this.doSearch()
      document.querySelector('.el-table__body-wrapper').scrollTop = 0 // 返回顶部
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.doSearch()
      document.querySelector('.el-table__body-wrapper').scrollTop = 0
    },
    // 删除
    deletePostSubmit(index, row) {
      if (row.firstRelease === 1) {
        this.$message({
          message: '首次发布记录不允许删除',
          type: 'error'
        })
        return
      }
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        deleteVersionUpdate(
          { id: row.id }
        ).then(res => {
          this.getlist()
        })
      }).catch(() => { })
    },
    // 打开更新对话框
    updateShow(index, row) {
      this.isNewVersion = false
      if (row.firstRelease === 1) {
        // 更新首次发布
        this.dialogTitle = '更新首次发布'
        this.addFirstReleaseFormVisible = true
        this.addFirstReleaseForm = Object.assign({}, row)
      } else {
        // 更新升级发布
        this.dialogTitle = '更新升级发布'
        this.updatePatchFormVisible = true
        this.updatePatchForm = Object.assign({}, row)
      }
    },
    /**
     * 调整表格列表数据
     */
    handleTableList(res) {
      this.tableList.forEach(item => {
        if (item.appType === 'mobile') {
          item.appTypeLabel = '移动应用'
        } else {
          item.appTypeLabel = 'Web应用'
        }
        if (item.firstRelease === 1) {
          item.firstReleaseLabel = '是'
        } else {
          item.firstReleaseLabel = '否'
        }
        if (item.packageName) {
          item.packageNameShow = item.packageName.replace(/-\d{13}$/, '')
        }
      })
      this.total = res.data.total
    },
    // 获取版本升级列表
    getlist() {
      selectPageVersionUpdate(
        this.page
      )
        .then(res => {
          if (res.code === 20000) {
            this.tableList = res.data.records
            this.handleTableList(res)
          }
        })
        .catch(err => {
          this.$notify({
            title: 'error',
            message: '获取列表失败:' + err,
            type: 'error'
          })
        })
    },
    // 获取版本升级列表
    getAppFullNamelist() {
      selectFirstReleaseList().then(res => {
        if (res.code === 20000) {
          this.firstReleaseList = res.data
          this.optionsAppFullName = []
          res.data.forEach(item => {
            this.optionsAppFullName.push({ label: item.appFullName, value: item.appName })
          })
        }
      })
    }
  },
  mounted() {
    this.getlist()
    this.resetAddFirstReleaseForm()
    this.resetUpdatePatchForm()
    this.getAppFullNamelist()
  }
}
</script>

<style scoped lang='scss'>
</style>
